/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteThemeGroupInput = {
    id: string;
};
export type apiDeleteThemegroupMutationVariables = {
    input: DeleteThemeGroupInput;
};
export type apiDeleteThemegroupMutationResponse = {
    readonly deleteThemeGroup: {
        readonly status: string;
    };
};
export type apiDeleteThemegroupMutation = {
    readonly response: apiDeleteThemegroupMutationResponse;
    readonly variables: apiDeleteThemegroupMutationVariables;
};



/*
mutation apiDeleteThemegroupMutation(
  $input: DeleteThemeGroupInput!
) {
  deleteThemeGroup(input: $input) {
    status
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteThemeGroupPayload",
    "kind": "LinkedField",
    "name": "deleteThemeGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiDeleteThemegroupMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiDeleteThemegroupMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f95f867610c086381e0c4e5076aab597",
    "id": null,
    "metadata": {},
    "name": "apiDeleteThemegroupMutation",
    "operationKind": "mutation",
    "text": "mutation apiDeleteThemegroupMutation(\n  $input: DeleteThemeGroupInput!\n) {\n  deleteThemeGroup(input: $input) {\n    status\n  }\n}\n"
  }
};
})();
(node as any).hash = '8d4868fec42577236d3b2e0919f020d5';
export default node;
